module.exports = __webpack_public_path__ + "img/sup_deposit_crypto11.74ddcfc5.jpg";